import {
  SET_SELECTED_REQUEST,
  RESET_SELECTED_REQUEST,
} from '../actions/acceptanceRequestToCalendarActions';

const initialState = { selectedRequest: undefined };

const acceptanceRequestToCalendarReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SET_SELECTED_REQUEST:
      return {
        ...state,
        selectedRequest: payload,
      };
    case RESET_SELECTED_REQUEST:
      return {
        ...state,
        selectedRequest: undefined,
      };
    default:
      return state;
  }
};

export const selectedRequestSelector = (state) =>
  state.acceptanceRequestToCalendarStore.selectedRequest;

export default acceptanceRequestToCalendarReducer;
